import {Cart} from "../cart/index.jsx";

const CheckoutForm = () => {

  return (<Cart />)
};

export default CheckoutForm;
